import { Component } from '@angular/core';

@Component({
  selector: 'medrecord-ui-page',
  templateUrl: './will-be-soon-page.component.html'
})
export class WillBeSoonPageComponent {}
